import {useTranslation} from "react-i18next";
import classNames from "classnames";
import React, {memo} from 'react';

import {SIZE, INTERACTION, BUTTON_VARIANT, STEPS_STATUS, formatNumberToEuropeanStyle} from "utils";
import {useGetUserItemOffersQuery} from "store/Bazaar/bazaar.api";
import {useActiveItemContext} from "./useActiveItemContext";
import {useModalsContext} from "layouts";

import BazaarCurrentItemInteractionToolsMake from "./BazaarCurrentItemInteractionToolsMake";
import BazaarCurrentItemAccordionBlock from "./BazaarCurrentItemAccordionBlock";
import CountDownBlock from "./CountDownBlock";
import {ButtonV2} from "components/atoms";

const BazaarCurrentItemInteractionToolsBuy = ({userUuid}) => {
    const {
        data,
        chainId,
        kompeteWethPrice,
        ethPrice,
        calculateKompetePrice,
        handleAuthAndWalletChecks
    } = useActiveItemContext()
    const {setCurrentModal} = useModalsContext()
    const {t} = useTranslation()

    const openModal = (status) => {
        if (!handleAuthAndWalletChecks()) return;

        const initialItemInfo = {
            chainId: chainId,
            name: data.inventory.name,
            tokenId: data?.details.token_id,
        }

        let itemInfo;

        if (status === STEPS_STATUS.MAKE_OFFER) {
            itemInfo = {
                ...initialItemInfo,
                chain: chainId,
            };
        } else {
            itemInfo = {
                ...initialItemInfo,
                tokenId: data?.details.token_id,
                listing: data.lucrative_listing,
                priceUSD: calculateKompetePrice(data?.lucrative_listing.price),
            }
        }

        setCurrentModal(prevState => ({...prevState, data: itemInfo, status}))
    }

    const isPricesAvailable = ethPrice !== null && kompeteWethPrice !== null;
    const kompetePriceStyle = classNames({"skeleton": !isPricesAvailable})
    const isBuyButtonDisabled = data?.lucrative_listing?.user.user_uuid === userUuid || kompeteWethPrice === null || ethPrice === null;

    return (
        <React.Fragment>
            {data?.lucrative_listing ? (
                <div className="bazaar_current-item_interaction-tools_btn-group_tabs-content_buy">
                    <span>{t("buyFor")}</span>
                    <div className="bazaar_current-item_interaction-tools_btn-group_tabs-content_buy_price">
                        <span>{formatNumberToEuropeanStyle(data?.lucrative_listing.price)} KOMPETE</span>
                        <span className={kompetePriceStyle}>
                              {isPricesAvailable ? calculateKompetePrice(data?.lucrative_listing.price) : ""}
                        </span>
                        <span>
                            {t("endingIn")} <CountDownBlock expirationDate={data?.lucrative_listing.expiration_date}/>
                        </span>
                    </div>
                    <div className="bazaar_current-item_interaction-tools_btn-group_tabs-content_buy_btns">
                        <ButtonV2
                            size={SIZE.MEDIUM}
                            variant={BUTTON_VARIANT.RED}
                            disabled={isBuyButtonDisabled}
                            onClick={() => openModal(STEPS_STATUS.CONFIRM_PURCHASE)}
                        >
                            buyNow
                        </ButtonV2>
                        <ButtonV2
                            size={SIZE.MEDIUM}
                            disabled={!isPricesAvailable}
                            onClick={() => openModal(STEPS_STATUS.MAKE_OFFER)}
                        >
                            makeOffer
                        </ButtonV2>
                    </div>
                    <BazaarCurrentItemAccordionBlock
                        totalOwnedNFT={0}
                        interaction={INTERACTION.BUY}
                        queryHook={useGetUserItemOffersQuery}
                    />
                </div>
            ) : <BazaarCurrentItemInteractionToolsMake/>}
        </React.Fragment>
    )
}

export default memo(BazaarCurrentItemInteractionToolsBuy)